import { SOURCE_LOCALE } from 'app-shared/constants';
import { type AppLocale } from 'app-shared/types';
import { isValidLocale } from 'app-shared/utils';

type DetectInitialLocaleArgs = {
  urlLocale: string | null;
  storedLocale: string | null;
  browserLanguages: readonly string[];
};

// A link with ?locale= wins, then the saved choice, then the browser
// settings; English is the fallback.
export const detectInitialLocale = ({
  urlLocale,
  storedLocale,
  browserLanguages,
}: DetectInitialLocaleArgs): AppLocale => {
  if (isValidLocale(urlLocale)) {
    return urlLocale;
  }

  if (isValidLocale(storedLocale)) {
    return storedLocale;
  }

  const browserLocale = browserLanguages
    .map((language) => language.split('-')[0])
    .find(isValidLocale);

  return browserLocale ?? SOURCE_LOCALE;
};
